import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Target routes
 * ----------------------------
 */

export const getTarget = (query, callback, force = false) => {
    cachiosInstance.get(`/target?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};